<script>
    import ProductCardsSlider from "@/components/product/ProductCardsSlider";

    export default {
        name: "ProductFooter",
        components: { ProductCardsSlider },
        props: {
            product: Object,
            title: String,
            breakpoints: Object,
            isSmallCards: Boolean,
            inCartList: Array,
        },
        data() {
            return {
                isAvailableSliderProducts: true,
            };
        },
        computed: {
            listIds() {
                return this.product?.similarProductsIds || [];
            },
        },
        methods: {
            onLoadedSliderProducts(payload) {
                this.isAvailableSliderProducts = payload;
            },
        },
    };
</script>

<template>
    <div class="product__footer">
        <div class="product-anchor-style js-anchor-similar"></div>
        <div v-if="listIds.length > 0 && isAvailableSliderProducts" class="product__similar">
            <h2 v-if="title" class="product__similar-title">{{ title }}</h2>
            <slot name="title"></slot>

            <product-cards-slider
                type="similar"
                :is-small="isSmallCards"
                :list-ids="listIds"
                :product-id="product.id"
                :breakpoints="breakpoints"
                :in-cart-list="inCartList"
                @on-loaded="onLoadedSliderProducts"
            >
            </product-cards-slider>
        </div>

        <div v-if="$slots.guarantee" class="product__guarantee">
            <slot name="guarantee"></slot>
        </div>
    </div>
</template>

<style lang="scss">
    .product__footer {
        padding-top: 40px;

        @include bp($bp-desktop-sm) {
            padding-top: 76px;
        }
    }

    .product__similar {
        margin-bottom: 40px;

        @include bp($bp-desktop-sm) {
            margin-bottom: 72px;
        }
    }

    .product__guarantee {
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-bottom: 56px;

        @include bp($bp-desktop-sm) {
            width: 100%;
            margin-left: 0;
            margin-bottom: 128px;
        }

        .guarantee-list__title {
            padding-left: 16px;

            @include bp($bp-desktop-sm) {
                padding-left: 0;
            }
        }
        .c-slider__swiper {
            padding: 0 16px;
            @include bp($bp-desktop-sm) {
                padding: 0;
            }
        }

        .c-slider__scrollbar {
            width: auto;
            margin: 0 16px;
            @include bp($bp-desktop-sm) {
                margin: 0;
                width: 100%;
            }
        }
    }
</style>
